// Also hardcoded (constant can't be imported there) — update together:
// - src/useragreement.html
// - src/privacyoverview.html
// - src/app/components/terms-and-conditions/terms-and-conditions.template.html
export const supportEmail = 'help@swymo.ai';
export const supportEmailHref = `mailto:${supportEmail}`;
